// extracted by mini-css-extract-plugin
export default {"Order":"Shipment_Order__zdPtb","main":"Shipment_main__K3wfo","upper":"Shipment_upper__4ziyV","box":"Shipment_box__6GxNx"};